export default __webpack_public_path__ + "static/images/share_icon.6abd437b.png";